var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2294 4.65631C13.9666 4.60406 13.752 4.44018 13.642 4.20585C12.4133 1.61631 9.57046 0.168348 6.72679 0.692432C4.13646 1.16743 2.10583 3.23527 1.67279 5.83906C1.54454 6.60777 1.55404 7.37726 1.69891 8.12697C1.74641 8.3716 1.64112 8.64393 1.425 8.84027C0.51854 9.66439 -0.000793457 10.8384 -0.000793457 12.0623C-0.000793457 14.4627 1.95225 16.4165 4.35337 16.4165H13.0617C16.336 16.4165 18.9992 13.7533 18.9992 10.479C18.9992 7.65672 16.9931 5.2081 14.2286 4.6571L14.2294 4.65631ZM11.9708 10.6429L9.82775 12.7859C9.52137 13.0923 9.11841 13.2467 8.71546 13.2483L8.70833 13.2498L8.70121 13.2483C8.29825 13.2467 7.89529 13.0923 7.58892 12.7859L5.44587 10.6429C5.13633 10.3333 5.13633 9.83301 5.44587 9.52347C5.75541 9.21393 6.25575 9.21393 6.56529 9.52347L7.91667 10.8748V6.91652C7.91667 6.47872 8.27133 6.12485 8.70833 6.12485C9.14533 6.12485 9.5 6.47872 9.5 6.91652V10.8748L10.8514 9.52347C11.1609 9.21393 11.6612 9.21393 11.9708 9.52347C12.2803 9.83301 12.2803 10.3333 11.9708 10.6429Z",
    fill: "#3B60E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadActive);
export default __webpack_public_path__ + "static/media/downloadActive.000c2c7e719870d503b1ef42766664af.svg";
export { ForwardRef as ReactComponent };